var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.currencies.length ? _c('div', {
    staticClass: "container course-container"
  }, [_c('div', {
    staticClass: "row row-full-width"
  }, [_c('div', {
    staticClass: "course-wrap"
  }, [_c('div', {
    staticClass: "course marquee"
  }, [_c('div', {
    staticClass: "marquee__inner",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._l(_vm.currencies, function (currency) {
    return [_c('span', {
      key: currency.code
    }, [_c('span', {
      staticClass: "course-item"
    }, [_vm._v(" " + _vm._s(currency.name))]), _vm._v(" " + _vm._s(currency.value) + " "), currency.up ? _c('img', {
      attrs: {
        "src": require("../../assets/img/course-icon-up.svg")
      }
    }) : _c('img', {
      attrs: {
        "src": require("../../assets/img/course-icon-down.svg")
      }
    })])];
  })], 2)])])])]) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }